// acciones
export const SAVE_LOADING = 'layoutReducer/SAVE_LOADING'
export const SAVE_HEADER_SHOW = 'layoutReducer/SAVE_SHOW_HEADER'
export const SAVE_INICIALIZANDO_USUARIO = 'layoutReducer/SAVE_INICIALIZANDO_USUARIO'
export const SAVE_PERMITE_USUARIO_ANONIMO = 'layoutReducer/SAVE_PERMITE_USUARIO_ANONIMO'


// funciones
export const setLoading = (payload) => ({
    type: SAVE_LOADING,
    payload
})

export const setHeaderShow = (payload) => ({
    type: SAVE_HEADER_SHOW,
    payload
})

export const setInicializandoUsuario = (payload) => ({
    type: SAVE_INICIALIZANDO_USUARIO,
    payload
})

export const setPermiteUsuarioAnonimo = (payload) => ({
    type: SAVE_PERMITE_USUARIO_ANONIMO,
    payload
})